import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

function DewanKomisaris() {
    useEffect(() => {
        AOS.init({
            duration: 850,
            once: true,
        });
    }, []);

    const komisarisData = [
        {
            nama: 'Teni Agustini',
            jabatan: 'Komisaris Utama',
            lokasi: 'Jakarta',
            pengalaman: '30+ tahun',
            pengalamanEksekutif: '15 tahun eksekutif',
            pendidikan: 'Magister Manajemen, angkatan 1994',
            ringkasan:
                'Merupakan Warga Negara Indonesia dan saat ini berdomisili di Jakarta. Beliau merupakan lulusan Magister Manajemen angkatan 1994.',
            deskripsi:
                'Beliau memiliki lebih dari 30 tahun pengalaman di industri telekomunikasi, termasuk 15 tahun di posisi eksekutif. Sebagai salah satu anggota tim pendiri IndiHome, jaringan serat optik pertama di Indonesia yang dikembangkan oleh PT Telekomunikasi Indonesia, beliau berkontribusi signifikan dalam transformasi layanan telekomunikasi nasional. Sepanjang kariernya, beliau pernah menjabat sebagai Direktur Utama PT TRG Investama dan PT Akses Prima Indonesia, serta mengemban peran strategis sebagai Komisaris di PT Telkom Akses, PT Patrakom, Telkom Vision, dan PT PSN.',
            gambar: '/assets-web/photo/teni_agustini_sqr.png',
        },
    ];

    return (
        <div className="py-4 lg:py-6">
            <div className="mb-7 flex flex-col gap-2" data-aos="fade-up">
                <span className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-600">
                    Pengawasan & Tata Kelola
                </span>
                <h2 className="text-3xl font-bold tracking-tight text-slate-950 sm:text-4xl">
                    Dewan Komisaris
                </h2>
                <p className="max-w-2xl text-justify text-sm leading-6 text-slate-500 sm:text-base">
                    Profil Dewan Komisaris PT Len Telekomunikasi Indonesia.
                </p>
            </div>

            {komisarisData.map((komisaris, index) => (
                <article
                    key={komisaris.nama}
                    className="group overflow-hidden rounded-[30px] border border-slate-200/80 bg-white shadow-[0_24px_70px_rgba(15,23,42,0.09)]"
                    data-aos="fade-up"
                    data-aos-delay={index * 80}
                >
                    <div className="grid lg:grid-cols-[340px_minmax(0,1fr)]">
                        <div className="relative overflow-hidden bg-gradient-to-br from-slate-950 via-[#0b2038] to-[#005da2] p-7 sm:p-8 lg:min-h-[520px]">
                            <div className="pointer-events-none absolute -right-20 -top-20 h-56 w-56 rounded-full border border-white/10 bg-white/[0.04]" />
                            <div className="pointer-events-none absolute -bottom-24 -left-16 h-64 w-64 rounded-full border border-blue-300/10 bg-blue-300/[0.04]" />

                            <div className="relative z-10 flex h-full flex-col justify-between gap-8">
                                <div>
                                    <span className="inline-flex rounded-full border border-white/15 bg-white/10 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-blue-100 backdrop-blur">
                                        {komisaris.jabatan}
                                    </span>
                                </div>

                                <div className="mx-auto w-full max-w-[250px] rounded-[26px] border border-white/15 bg-white/10 p-3 shadow-2xl shadow-black/20 backdrop-blur-sm">
                                    <Zoom>
                                        <img
                                            src={komisaris.gambar}
                                            alt={komisaris.nama}
                                            loading="lazy"
                                            className="aspect-[4/5] w-full cursor-zoom-in rounded-[20px] bg-white object-contain object-bottom"
                                        />
                                    </Zoom>
                                </div>

                                <div>
                                    <p className="text-sm font-medium text-blue-200">PT Len Telekomunikasi Indonesia</p>
                                    <h3 className="mt-1 text-2xl font-bold tracking-tight text-white">
                                        {komisaris.nama}
                                    </h3>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-col justify-center p-7 sm:p-10 lg:p-12 xl:p-14">
                            <div className="mb-7 flex flex-wrap gap-2">
                                <span className="rounded-full bg-slate-100 px-3 py-1.5 text-xs font-semibold text-slate-700">
                                    Domisili {komisaris.lokasi}
                                </span>
                                <span className="rounded-full bg-blue-50 px-3 py-1.5 text-xs font-semibold text-blue-700">
                                    {komisaris.pengalaman}
                                </span>
                                <span className="rounded-full bg-blue-50 px-3 py-1.5 text-xs font-semibold text-blue-700">
                                    {komisaris.pengalamanEksekutif}
                                </span>
                            </div>

                            <div className="mb-8 border-l-4 border-blue-600 pl-5">
                                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-600">Profil</p>
                                <p className="mt-2 text-sm font-medium leading-6 text-slate-500">
                                    {komisaris.pendidikan}
                                </p>
                            </div>

                            <div className="space-y-5 text-justify text-[15px] leading-7 text-slate-600 [text-justify:inter-word] sm:text-base sm:leading-8">
                                <p>{komisaris.ringkasan}</p>
                                <p>{komisaris.deskripsi}</p>
                            </div>
                        </div>
                    </div>
                </article>
            ))}
        </div>
    );
}

export default DewanKomisaris;
